import isObject from 'lodash/isObject';
import isBoolean from 'lodash/isBoolean';
import each from 'lodash/each';
import keys from 'lodash/keys';

import type { ShopInsuranceTypes } from '@jerry-serverless/types';

export type { ShopInsuranceTypes };

/**
 * Parse `ShopInsuranceTypes` object from json object.
 *
 * @param obj
 */
export const parseShopForInsuranceTypes = (obj: Record<string, boolean>): ShopInsuranceTypes => {
  const shopFor: ShopInsuranceTypes = {
    home: false,
    renters: false,
    umbrella: false,
    condo: false,
  };

  if (isObject(obj)) {
    each(keys(shopFor), (key) => {
      if (isBoolean(obj[key])) {
        shopFor[key] = obj[key];
      }
    });
  }

  return shopFor;
};
